/**
 * Format a numeric value as a currency string with exactly two decimal places
 * and thousands separators (en-IN locale produces "1,23,456.78").
 *
 * Handles null / undefined / non-numeric input gracefully, falling back to "0.00".
 *
 * @param {number|string|null|undefined} value - The amount to format.
 * @returns {string} The formatted currency string, e.g. "1,23,456.78".
 */
export const formatCurrency = (value) => {
    const numeric = Number(value);
    if (value === null || value === undefined || value === "" || Number.isNaN(numeric)) {
        return "0.00";
    }
    return numeric.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};